// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Swiper from 'swiper/js/swiper';

const fragments = {
	SWIPER: '[data-fragment="TileSlider.swiper"]',
	LINK: '[data-fragment="TileSlider.link"]',
	PREV: '[data-fragment="TileSlider.prev"]',
	NEXT: '[data-fragment="TileSlider.next"]',
	PAGINATION: '[data-fragment="TileSlider.pagination"]',

};

export default class TileSlider extends WebComponent {
	constructor (props) {
		super(props);
	}

	didMount() {
		this.swiperElement = this.element.querySelector(fragments.SWIPER);
		this.swipers = new Swiper(this.swiperElement, {
			slidesPerView: 1,
			speed: 1000,
			loop: true,
			navigation: {
				nextEl: fragments.NEXT,
				prevEl: fragments.PREV,
			},
			pagination: {
				el: fragments.PAGINATION,
				clickable: true,
			},
			autoplay: {
				delay: this.props.delay ? this.props.delay : 5000,
			},
		});

		this.on('click', fragments.LINK, this.handleClickOnLink);
	}


	handleClickOnLink = (e) => {
		const link = e.target.closest(fragments.LINK);
		const title = link.querySelector('.tile__title');
		const href = link.getAttribute('href');
		window.dataLayer.push({
			event: 'click_banner',
			click_banner: {
				name: 'tile_banner',
				area: 'body',
				url: href,
				text: title ? title.textContent : '',
			},
			_clear: true,
		});

	}
	willUnMount() {}
	update() {}
}



// WEBPACK FOOTER //
// ./fe/web-bn/src/js/components/TileSlider.js